import { ParamListBase, StackNavigationState } from '@react-navigation/native'
import { createStackNavigator, StackNavigationEventMap, StackNavigationOptions } from '@react-navigation/stack'
import { withLayoutContext } from 'expo-router'

const { Navigator } = createStackNavigator()

// expo-savvy js stack component, so we can have more control over animations and styling.
// see: https://docs.expo.dev/router/advanced/stack/#javascript-stack-with-react-navigationstack
export const StackNavigator = withLayoutContext<
  StackNavigationOptions,
  typeof Navigator,
  StackNavigationState<ParamListBase>,
  StackNavigationEventMap
>(Navigator)
